module.exports = __webpack_public_path__ + "img/nav-0.d266b5e.png";